import React, { useState, useEffect, useRef, useContext } from 'react';
import PropTypes from 'prop-types';
import { AppState } from '../lib/context/AppProvider';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { getDayOfYear } from '../utils/time';

const REMOTE_SYNC_INTERVAL = 60 * 60 * 1000; // 1 minute

const fetchSimTime = async (getData) => {
    const response = await getData("get-sim-time");
    return {
        simTime: new Date(response.SimTime).getTime(),
        simSpeed: response.SimSpeed,
        paused: response.Paused,
        realTime: Date.now()
    };
}

const getSimTime = async (lastFetched, lastFetchedValue, getData) => {
    if(!lastFetched.current || Date.now() - lastFetched.current > REMOTE_SYNC_INTERVAL) {
        lastFetchedValue.current = await fetchSimTime(getData);
        lastFetched.current = Date.now();
    }

    if(!lastFetchedValue.current) return null;

    const {simTime, simSpeed, paused, realTime} = lastFetchedValue.current;
    const elapsed = Date.now() - realTime;
    const currentSimTime = new Date(simTime + (paused ? 0 : simSpeed * elapsed));
    return {...lastFetchedValue.current, currentSimTime};
}

const formatTime = (time) => {
    const dayName = time.toLocaleString('en-US', { weekday: 'short' });
    const day = time.getUTCDate().toString().padStart(2, '0');
    const month = time.toLocaleString('en-US', { month: 'short' });
    const year = time.getUTCFullYear().toString().slice(-2);
    const julianDay = getDayOfYear(time);
    const hours = time.getUTCHours().toString().padStart(2, '0');
    const minutes = time.getUTCMinutes().toString().padStart(2, '0');
    const seconds = time.getUTCSeconds().toString().padStart(2, '0');

    return `${dayName}, ${day} ${month} ${year} (${julianDay}) | ${hours}:${minutes}:${seconds} UTC`;
};

const Clock = ({ className }) => {
    const {getData, simTime, setSimTime, exercise} = useContext(AppState);
    const [time, setTime] = useState(new Date());

    const lastFetched = useRef(null);
    const lastFetchedValue = useRef(null);

    useEffect(() => {
        const timer = setInterval(async () => {
            setTime(new Date());
            if(exercise?.hasSimTime) {
                setSimTime(await getSimTime(lastFetched, lastFetchedValue, getData));
            }
        }, 1000);

        return () => clearInterval(timer);
    }, [getData, setSimTime, exercise]);

    return (simTime ?
        <OverlayTrigger
            placement={"bottom"}
            overlay={
                <Tooltip>
                    <b>Real Time: </b>{formatTime(time)}
                    <br />
                    <b>Sim Speed: </b>{simTime.paused ? (<span style={{color: "red"}}>PAUSED</span>) : `${simTime.simSpeed}x`}
                </Tooltip>
            }
        >
            <span className={`text-white ${className}`} style={{ marginLeft: '10px' }}>
                <span style={{color: simTime.paused ? "red" : "#1ab000"}}>SIM: </span>{formatTime(simTime.currentSimTime)}
            </span>
        </OverlayTrigger>
        :
        <span className={`text-white ${className}`} style={{ marginLeft: '10px' }}>
            {formatTime(time)}
        </span>
    );
};

Clock.propTypes = {
    className: PropTypes.string
};

export default Clock; 